import { Component, input } from '@angular/core';
import { GcIconName, IpoTranslatePipe } from '@ip-only/front-end-library';
import { SideMenuButtonComponent } from './side-menu-button/side-menu-button.component';

export interface SideMenuLink {
  icon: GcIconName;
  label: string;
  url: string;
}

@Component({
  selector: 'app-side-menu',
  imports: [SideMenuButtonComponent, IpoTranslatePipe],
  templateUrl: 'side-menu.component.html',
})
export class SideMenuComponent {
  links = input.required<SideMenuLink[]>();
}
